import { memo } from "react";
import Page from "components/page/Page";
import { Helmet } from "react-helmet";
import GoogleAd from "components/googleAd/GoogleAd";
import Card from "components/card/Card";
import { PageCollapseWidth } from "../../constants";
import { useAppDispatch, useAppSelector } from "hooks";
import encodeSlice from "reducers/encodeSlice";
import { RootState } from "store";
import {
  busySelector,
  errorSelector,
  outputSelector,
} from "selectors/encodeSelectors";
import Base64EncodeInfo from "components/base64EncodeInfo/Base64EncodeInfo";
import EncodeOutput from "components/encodeOutput/EncodeOuput";
import EncodeInput from "components/encodeInput/EncodeInput";

const Base64EncodePage = () => {
  const dispatch = useAppDispatch();

  const handleSubmit = (input: any) => {
    dispatch(encodeSlice.actions.base64Encode({ input }));
  };

  const busy = useAppSelector((state: RootState) => busySelector(state));

  const error = useAppSelector((state: RootState) => errorSelector(state));

  const output = useAppSelector((state: RootState) => outputSelector(state));

  return (
    <>
      <Helmet>
        <title>
          Base64 Encode Online – Convert Text to Base64 | ToolWeaver
        </title>
        <meta
          name="description"
          content="Free online Base64 encoder. Convert text to Base64 instantly. Your input is processed to produce the result and is not stored."
        />
        <link rel="canonical" href="https://toolweaver.com/base64encode" />
      </Helmet>
      <Page>
        <GoogleAd hideOnWidth={PageCollapseWidth} />
        <Card collapseOnWidth={PageCollapseWidth} title="Base64 Encoder">
          {!output && (
            <EncodeInput
              onSubmit={handleSubmit}
              busy={busy}
              error={error}
              buttonText="Encode"
              header="Enter your unencoded piece of text and click the 'Encode' button."
            />
          )}
          {output && (
            <EncodeOutput
              output={output}
              header="Your encoded text is below."
            />
          )}
        </Card>

        <GoogleAd showOnWidth={PageCollapseWidth} type="medium-rectangle" />
        <GoogleAd hideOnWidth={PageCollapseWidth} />
        <Card
          isLast={true}
          collapseOnWidth={PageCollapseWidth}
          title="How does Base64 encoding work?"
          headingLevel={2}
        >
          <Base64EncodeInfo />
        </Card>
      </Page>
    </>
  );
};

export default memo(Base64EncodePage);
